/**
 * @generated SignedSource<<9c0b211f77a6c89de84f61c48d58a18c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type saleByOwnerPageQuery$variables = Record<PropertyKey, never>;
export type saleByOwnerPageQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"saleByOwnerGridFragment" | "saleByOwnerProcessedGridFragment">;
  } | null | undefined;
};
export type saleByOwnerPageQuery = {
  response: saleByOwnerPageQuery$data;
  variables: saleByOwnerPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caseId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caseAddress",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caseZipAndCity",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "saleByOwnerPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "saleByOwnerGridFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "saleByOwnerProcessedGridFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "saleByOwnerPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "propertyForSaleByOwnerLeads",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusType",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isLeadInterface"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LeadTypeGraphType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "presentationDate",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "type": "LeadPresentation",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "openHouseStartTime",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "type": "LeadOpenHouse",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "type": "LeadSalesMaterialWithContact",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AppointmentActivityType",
            "kind": "LinkedField",
            "name": "propertyForSaleByOwnerAppointmentActivityTypes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2751717e15317b49a74edf7b15366a32",
    "id": null,
    "metadata": {},
    "name": "saleByOwnerPageQuery",
    "operationKind": "query",
    "text": "query saleByOwnerPageQuery {\n  viewer {\n    ...saleByOwnerGridFragment\n    ...saleByOwnerProcessedGridFragment\n    id\n  }\n}\n\nfragment leadContactDialogContentFragment on LeadInterface {\n  __isLeadInterface: __typename\n  id\n  phoneNumber\n  email\n}\n\nfragment leadDialogContent on LeadInterface {\n  __isLeadInterface: __typename\n  __typename\n  ...leadContactDialogContentFragment\n  ...leadPresentationDialogContent\n  ...leadOpenHouseDialogContent\n}\n\nfragment leadDialogContentViewer on Viewer {\n  ...leadPresentationDialogContentViewer\n  ...leadOpenHouseDialogContentViewer\n}\n\nfragment leadListItemFragment on LeadInterface {\n  __isLeadInterface: __typename\n  id\n  __typename\n  ... on LeadPresentation {\n    comment\n    presentationDate\n    caseAddress\n    caseZipAndCity\n  }\n  ... on LeadOpenHouse {\n    openHouseStartTime\n    comment\n    caseAddress\n    caseZipAndCity\n  }\n  ... on LeadSalesMaterialWithContact {\n    comment\n    caseAddress\n    caseZipAndCity\n  }\n  email\n  phoneNumber\n  firstName\n  lastName\n  type {\n    id\n    displayName\n  }\n  statusType\n  ...leadDialogContent\n}\n\nfragment leadOpenHouseDialogContent on LeadInterface {\n  __isLeadInterface: __typename\n  id\n  __typename\n  ... on LeadOpenHouse {\n    openHouseStartTime\n    firstName\n    lastName\n    phoneNumber\n    email\n    caseId\n  }\n}\n\nfragment leadOpenHouseDialogContentViewer on Viewer {\n  propertyForSaleByOwnerAppointmentActivityTypes {\n    category\n    id\n  }\n}\n\nfragment leadPresentationDialogContent on LeadInterface {\n  __isLeadInterface: __typename\n  id\n  __typename\n  ... on LeadPresentation {\n    firstName\n    lastName\n    phoneNumber\n    email\n    caseId\n  }\n}\n\nfragment leadPresentationDialogContentViewer on Viewer {\n  propertyForSaleByOwnerAppointmentActivityTypes {\n    category\n    id\n  }\n}\n\nfragment saleByOwnerGridFragment on Viewer {\n  propertyForSaleByOwnerLeads {\n    statusType\n    id\n    __typename\n    ...leadDialogContent\n    ...leadListItemFragment\n  }\n  ...leadDialogContentViewer\n}\n\nfragment saleByOwnerProcessedGridFragment on Viewer {\n  propertyForSaleByOwnerLeads {\n    statusType\n    id\n    __typename\n    ...leadListItemFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "6850aa7698669085af26e5debbe1265d";

export default node;
